import { Select } from '@softwaredev_cegeka/stix-form-select'
// do not rewrite this import -> circular dependencies
import CreatableSelect from '@softwaredev_cegeka/stix-form-select/dist/components/CreatableSelect'
import { Icon } from '@softwaredev_cegeka/stix-core'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash.isequal'
import axios from 'axios'

import { serializeParamsWithoutBrackets } from 'src/utils/utils'

class AsyncSelect extends Component {
    state = {
        loading: false,
        options: [],
        menuOpened: '',
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.dependencies, this.props.dependencies)) {
            this.setState({ options: [] }, () => {
                this.loadOptions()
            })
        }
    }

    componentDidMount() {
        this.loadOptions()
    }

    handleMenuOpen = () => {
        if (!this.state.menuOpened) {
            this.setState(
                {
                    menuOpened: true,
                },
                () => {
                    this.loadOptions()
                }
            )
        }
    }

    handleMenuClose = () => this.setState({ menuOpened: false, options: [] })

    loadOptions = (input = '') => {
        const { url, params } = this.props.apiConfig
        const { onHideIfEmpty } = this.props
        this.query = input
        try {
            axios
                .get(url, {
                    params: params(input),
                    paramsSerializer: serializeParamsWithoutBrackets,
                })
                .then(response => {
                    if (input === this.query) {
                        if (
                            onHideIfEmpty instanceof Function &&
                            input === '' &&
                            response.data.results.length === 0
                        ) {
                            onHideIfEmpty()
                            return
                        }
                        const options = this.props.itemRenderer(response)
                        this.setState({
                            options,
                        })
                    }
                })
        } catch (ex) {
            console.error(ex)
            this.setState({ options: [] })
        }
    }

    render() {
        let SelectComponent = this.props.comboBox ? CreatableSelect : Select
        return (
            <SelectComponent
                {...this.props}
                options={this.state.options}
                isLoading={this.state.loading}
                dropDownIndicator={
                    this.props.search ? <Icon icon="search" /> : null
                }
                onMenuOpen={this.handleMenuOpen}
                onMenuClose={this.handleMenuClose}
                onInputChange={(input, event) => {
                    if (event.action === 'input-change') {
                        this.loadOptions(input)
                    }
                }}
            />
        )
    }
}

AsyncSelect.propTypes = {
    // these are not all the props but they're the ones you need to know about
    search: PropTypes.bool,
    label: PropTypes.string,
    required: PropTypes.bool,
    itemRenderer: PropTypes.func.isRequired,
    apiConfig: PropTypes.shape({
        url: PropTypes.string.isRequired,
        params: PropTypes.func.isRequired,
    }).isRequired,
    onHideIfEmpty: PropTypes.func,
}

export default AsyncSelect
